import { db } from '../../config/Firebase'
import { Action } from './types'

export const retrieveInitialData = (collection, action, orderBy) => {
    return async (dispatch, getStore) => {
        //console.log("Obteniendo requests")
        dispatch({ type: Action.REQUESTS_LOADING })
        try{
            const limit = 15
            //query to get all requests ordered by date of creation
            let initialQuery = await db.collection(collection)
                .orderBy(orderBy.field, orderBy.order)
                .limit(limit)

            let documentSnapshots = await initialQuery.get()
            //console.log("documents: ", documentSnapshots.docs)

            //create a reference for users
            //let users = await db.collection('users')
            //create array of requests data
            let documentData = documentSnapshots.docs.map( document => {
                
                const request = {
                    data: document.data(),
                    id: document.id
                }
                //document.data() 
                return request
            })

            //let's save the lastVIsible to paginate new results
            //let lastVisible = documentData[documentData.length - 1]
            let lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1]
            const lastPage = documentSnapshots.docs.length < limit ? true : false
            //we save the list on our store
            dispatch({ type: action, payload: { list: documentData, lastVisible, lastPage } })

        } catch(error) {
            console.log("get requests error: ", error)
            dispatch({ type: Action.REQUESTS_GET_ERROR, payload: error})
        }
    }
}

export const retrieveMoreData = (collection, action, orderBy) => {
    return async (dispatch, getStore) => {
        //console.log("retrieve more data")
        dispatch({ type: Action.REQUESTS_LOADING })
        try{
            let { lastVisible } = getStore().admin[collection]
            const limit = 10
            let additionalQuery = await db.collection(collection)
                .orderBy(orderBy.field, orderBy.order)
                .startAfter(lastVisible)
                .limit(limit)

            let documentSnapshots = await additionalQuery.get()

            //create array of requests data
            let documentData = documentSnapshots.docs.map( document => {
                
                const request = {
                    data: document.data(),
                    id: document.id
                }
                //document.data() 
                return request
            })

            //let's save the lastVIsible to paginate new results
            //lastVisible = documentData[documentData.length - 1]
            lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1]
            const lastPage = documentSnapshots.docs.length < limit ? true : false
            //we save the list on our store
            dispatch({ type: action, payload: { list: documentData, lastVisible, lastPage } })

        } catch(error) {
            console.log("get requests error: ", error)
            dispatch({ type: Action.REQUESTS_GET_ERROR, payload: error})
        }
    }
}

export const setCurrentRequest = (index) => {
    return (dispatch) => {
        //console.log("action: ", index)
        dispatch({ type: Action.REQUESTS_CURRENT_REQUEST, payload: index})
    }
}

export const initializeDiagnosis = () => {
    return (dispatch) => {
        dispatch({ type: Action.REQUESTS_INITIALIZE_DIAGNOSIS })
    }
}

export const setDiagnosis = (name, event) => {
    return (dispatch) => {
        dispatch({ type: Action.REQUESTS_SET_DIAGNOSIS, payload: {name, event}})
    }
}